import { render, staticRenderFns } from "./EdenServicePartners.vue?vue&type=template&id=d373e19e"
import script from "./EdenServicePartners.vue?vue&type=script&lang=js"
export * from "./EdenServicePartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports